import styles from "./styles/EventListItemLoading.module.scss";

const EventListItemLoading = () => {
  return (
    <div className={styles.loadingContainer}>
      <div className={styles.row}>
        <div className={styles.column}>
          <div className={styles.content + " " + styles.title} />
          <div className={styles.content + " " + styles.contentLine} />
          <div className={styles.content + " " + styles.contentLine} />
          <div className={styles.content + " " + styles.contentLine} />
        </div>
      </div>
    </div>
  );
};

export default EventListItemLoading;
